export enum COUNTRY_CODE {
  GERMANY = "DE",
  AUSTRIA = "AT",
  SWITZERLAND = "CH",
  POLAND = "PL",
  ENGLAND = "EN",
  ZULU = "ZU",
  CZECHIA = "CZ",
  SLOVAKIA = "SK",
  UNITED_KINGDOM = "GB",
  USA = "US",
}

export type CountryCode = (typeof COUNTRY_CODE)[keyof typeof COUNTRY_CODE];

export enum MARKETS {
  DE = COUNTRY_CODE.GERMANY,
  PL = COUNTRY_CODE.POLAND,
  CZ = COUNTRY_CODE.CZECHIA,
  GB = COUNTRY_CODE.UNITED_KINGDOM,
  SK = COUNTRY_CODE.SLOVAKIA,
  US = COUNTRY_CODE.USA,
}

export type SupportedCountryPostcodes =
  | COUNTRY_CODE.GERMANY
  | COUNTRY_CODE.AUSTRIA
  | COUNTRY_CODE.SWITZERLAND
  | COUNTRY_CODE.POLAND
  | COUNTRY_CODE.USA
  | COUNTRY_CODE.UNITED_KINGDOM;

export enum CURRENCY_CODE {
  EUR = "EUR",
  PLN = "PLN",
  GBP = "GBP",
  CZK = "CZK",
}

export type CurrencyCode = (typeof CURRENCY_CODE)[keyof typeof CURRENCY_CODE];
